import YtbRootLayout from "@/components/corp/ytb/layout/YtbRootLayout.vue";
import YtbHome from "@/views/corp/ytb/YtbHome.vue";

const ytbSubPageMeta = { ytbMode: "page", requiresAuth: false, ytbAccess: true };

/** /ytb 路由树 + 未知子路径回首页 ( 不走 EW 菜单；子页由 YtbAccess 密码门控 ) */
export const ytbRootRoute = {
  path: "/ytb",
  component: YtbRootLayout,
  meta: { requiresAuth: false },
  children: [
    { path: "", name: "YtbHome", component: YtbHome, meta: { ytbMode: "home", requiresAuth: false } },
    { path: "youtube", name: "YtbYoutube", component: () => import("@/views/corp/ytb/Youtube/index.vue"), meta: { ...ytbSubPageMeta, documentTitle: "YouTube 工具" } },
    { path: "studio", name: "YtbStudio", component: () => import("@/views/corp/ytb/Studio/index.vue"), meta: { ...ytbSubPageMeta, documentTitle: "AI 自动出片" } },
    { path: "scys-deepsea", name: "YtbScysDeepsea", component: () => import("@/views/corp/ytb/ScysDeepsea/index.vue"), meta: { ...ytbSubPageMeta, documentTitle: "甜甜圈文章" } },
  ],
};

export const ytbUnknownRedirect = { path: "/ytb/:pathMatch(.*)*", redirect: "/ytb" };

/** 全站 router 用 */
export const ytbRoutesForApp = [ytbRootRoute, ytbUnknownRedirect];

/** YTB 独立构建：无关路径统一回 /ytb */
export const ytbStandaloneCatchAll = { path: "/:pathMatch(.*)*", redirect: "/ytb" };

export const ytbRoutesForStandalone = [...ytbRoutesForApp, ytbStandaloneCatchAll];
